export default "/images/code.svg?5006cb1eb2fba36c6c80bfb24f55e45a";